import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, admin = false, skipAgeCheck = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[50vh] flex items-center justify-center text-neutral-500" data-testid="protected-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Age gate: any authenticated user missing DOB / age_verified_at is redirected to complete verification.
  // Admins and the verify-age page itself bypass this check.
  if (!skipAgeCheck && user.role !== "admin" && (!user.date_of_birth || !user.age_verified_at)) {
    return <Navigate to="/verify-age" replace />;
  }
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
